import React from 'react';
import heart3d from './heart-3d.png';
import './AnimatedHeartMarker.scss';

// JAA-90: DOM-based animated heart marker — pure "activity signal", no count.
// Mounted by BuildingMap via mapboxgl.Marker. CSS keyframes drive a pop +
// rise + fade loop mirroring Figma frames 2029:6067..2029:6070.
//
// The heart is IMPORTED (not a /public path) so CRA inlines it as a data-URI
// (it's <10KB). A new marker is mounted per spawned heart (bursts + idle
// trickle); a network <img> per heart floods the connection pool (and re-fetches
// under "Disable cache"). A data-URI src costs zero requests, no matter how many.
export default function AnimatedHeartMarker({ scale = 1 }: { scale?: number }) {
  return (
    <div
      className="animated-heart-marker"
      style={scale === 1 ? undefined : { transform: `scale(${scale})` }}
    >
      <div className="animated-heart-marker__shadow" />
      <div className="animated-heart-marker__heart">
        <img src={heart3d} alt="" className="animated-heart-marker__heart-img" />
      </div>
    </div>
  );
}
